import { useEffect, useRef, useState } from "react";
import { useInView } from "framer-motion";
import { Users, PanelsTopLeft, CalendarCheck, Wrench } from "lucide-react";
import { STATS } from "@/data/site";
import { Reveal, useLang } from "./common";

const ICONS = [Users, PanelsTopLeft, CalendarCheck, Wrench];

const Count = ({ to }) => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, amount: 0.6 });
  const [n, setN] = useState(0);
  useEffect(() => {
    if (!inView) return;
    const start = performance.now();
    const dur = 1600;
    let raf;
    const step = (t) => {
      const p = Math.min(1, (t - start) / dur);
      setN(Math.round(to * (1 - Math.pow(1 - p, 3))));
      if (p < 1) raf = requestAnimationFrame(step);
    };
    raf = requestAnimationFrame(step);
    return () => cancelAnimationFrame(raf);
  }, [inView, to]);
  return <span ref={ref}>{n.toLocaleString("en-IN")}+</span>;
};

export const Stats = () => {
  const { t, lang } = useLang();
  return (
    <section data-testid="stats-band" className="relative bg-[#0F295B] grain overflow-hidden py-16 sm:py-20 border-y border-white/10">
      <div className="relative max-w-[1200px] mx-auto px-5 sm:px-8 grid grid-cols-2 lg:grid-cols-4 gap-x-6 gap-y-12">
        {STATS.map((s, i) => {
          const I = ICONS[i];
          return (
            <Reveal key={i} delay={i * 0.1} className="text-center">
              <div data-testid={`stats-item-${i}`} className="flex flex-col items-center">
                <span className="w-16 h-16 rounded-full border border-white/25 grid place-items-center">
                  <I className="w-7 h-7 text-white" strokeWidth={1.5} />
                </span>
                <p className="font-display text-4xl sm:text-5xl text-white mt-5" key={lang}>
                  <Count to={s} />
                </p>
                <p className="text-slate-300 mt-2 text-sm sm:text-base">{t.stats[i]}</p>
              </div>
            </Reveal>
          );
        })}
      </div>
    </section>
  );
};
